module.exports = __webpack_public_path__ + "media/aeteratoken.01950a8f.mp4";